import { api } from './client';
import type { AuthUser } from './auth';

export type UpdateUserParams = {
  display_name?: string;
  first_name?: string;
  last_name?: string;
  avatar_icon?: string;
  avatar_color?: string;
};

/**
 * Update the current user's profile
 */
export async function updateProfile(params: UpdateUserParams): Promise<AuthUser> {
  const response = await api.patch('/me', params);
  return response.data;
}

export type ChangePasswordParams = {
  current_password: string;
  new_password: string;
  password_confirmation: string;
};

/**
 * Change the current user's password
 */
export async function changePassword(params: ChangePasswordParams): Promise<void> {
  await api.patch('/me/password', params);
}
